import { useEffect, useState } from 'react';
import { FamlaServices } from '../services';
import { useAppSelector } from '../stores';

/**
 * Interroge GET /mapping/force-status/:processId (même source que le bouton « forcer la carto »).
 * Retourne `null` tant que la réponse n’est pas connue.
 */
export function useAllInterviewsCompleted(processId: string | undefined): boolean | null {
    const [done, setDone] = useState<boolean | null>(null);
    const users = useAppSelector((state) => state.auth);

    useEffect(() => {
        if (!processId) {
            setDone(null);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const data = await FamlaServices(
                    'api_host',
                    `/mapping/force-status/${processId}`,
                    'GET',
                    '',
                    users.access_token
                );
                if (cancelled) return;
                if (data.status === 200 && data.body?.data && typeof data.body.data.all_interviews_completed === 'boolean') {
                    setDone(data.body.data.all_interviews_completed);
                } else {
                    setDone(false);
                }
            } catch {
                if (!cancelled) setDone(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [processId, users.access_token]);

    return done;
}
